import { render, staticRenderFns } from "./breakdownRegular.vue?vue&type=template&id=1f7b9e03&scoped=true"
import script from "./breakdownRegular.vue?vue&type=script&lang=js"
export * from "./breakdownRegular.vue?vue&type=script&lang=js"
import style0 from "./breakdownRegular.vue?vue&type=style&index=0&id=1f7b9e03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7b9e03",
  null
  
)

export default component.exports